import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import CloudDownloadIcon from 'material-ui-icons/CloudDownload';

import 'downloadjs';
import { ListItemIcon } from 'material-ui/List';
import download from 'downloadjs';

import { Document, Page } from 'react-pdf';
import Blur from '../../../hooks/UseCssBlur';

const styles = (theme) => ({
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary[500],
      '& $text, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  icon: {
    color: 'inherit',
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  popperClose: {
    pointerEvents: 'none',
  },
});

class OfferPresentation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      offerPresentationUrl: props.offerPresentationUrl,
      numPages: null,
      pageWidth: window.innerWidth * 0.5,
      pageHeight: window.innerHeight * 0.5,
    };

    this.handleResize = this.handleResize.bind(this);
  }
  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages });
  };

  handleClick = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleDownloadClick = (event) => {
    download(this.state.offerPresentationUrl);
    this.handleClose();
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.setState({
      pageWidth: window.innerWidth * 0.5,
      pageHeight: window.innerHeight * 0.5,
    });
  }

  render() {
    const {
      classes,
      offerPresentationUrl,
      offerPresentationTitle,
      isAuthenticated,
    } = this.props;
    const isPreview = window.location.href.indexOf('offer-preview') > -1;
    const { pageWidth, pageHeight } = this.state;
    const showBlur = !isPreview && !isAuthenticated;
    return (
      <div>
        <div
          className='max-width-div add-margin'
          style={{ padding: '50px 0px 0px 0px', overflow: 'auto' }}
        >
          <div className='black-44'>Presentation</div>
          <Blur radius={showBlur ? '5px' : '0'} transition='400ms'>
            <div className='offertitle'>{offerPresentationTitle} (Preview)</div>

            <div className='highlight w-inline-block'>
              <Document
                file={offerPresentationUrl}
                onLoadSuccess={this.onDocumentLoad}
              >
                <Page pageNumber={1} width={pageWidth} height={pageHeight} />
              </Document>

              <div className={classes.root}>
                <button
                  className='btn-small-outline w-button'
                  style={{ width: 'inherit' }}
                  onClick={!isAuthenticated ? null : this.handleDownloadClick}
                >
                  <ListItemIcon className={classes.icon}>
                    <CloudDownloadIcon />
                  </ListItemIcon>
                  Download PDF
                </button>
              </div>
            </div>
          </Blur>
        </div>
      </div>
    );
  }
}

OfferPresentation.propTypes = {
  classes: PropTypes.object.isRequired,
  offerPresentationUrl: PropTypes.string,
  offerPresentationTitle: PropTypes.string,
};

export default withStyles(styles)(OfferPresentation);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferPresentation/index.js